// @flow strict
import * as React from 'react'
import ReactGA from 'react-ga'
import styles from './CallToAction.module.scss'
import { Button } from '@mondough/public-web-components'

export type Props = {
  text: string,
  cta: string,
  category: string,
  action: string,
  label: string,
  href: string,
}

function navigateTo(url) {
  if (window) {
    window.location = url
  }
}

const CallToAction = (props: Props) => {
  const { text, cta, href, category, action, label } = props

  const handleClick = (e: SyntheticMouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    const { href } = e.currentTarget
    const errorTimeout = setTimeout(() => {
      navigateTo(href)
    }, 250)

    ReactGA.ga('send', {
      hitCallback: function() {
        clearTimeout(errorTimeout)
        navigateTo(href)
      },
      hitType: 'event',
      transport: 'beacon',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    })

    if (href.indexOf('https://app.adjust.com') > -1) {
      // We are using the existance of adjust links to identify download buttons
      // that take you directly to the app / play store to download.
      // We only want to fire these Facebook events for those buttons.
      window.fbq &&
        window.fbq('track', 'InitiateCheckout', {
          url: window.location.pathname,
        })
    }
  }

  return (
    <div className={styles.container}>
      <p className={styles.text}>{text}</p>
      <Button href={href} onClick={handleClick}>
        {cta}
      </Button>
    </div>
  )
}

export default CallToAction
